
<template>
  <div>
    <dialog-loading v-if="saving" loadingText='Salvando...'></dialog-loading>
    <v-alert dense border="left"
      :value="true" :type="status_map[client_credit.data.attributes.status_id].type">
      <v-row align="center">
        <div class="d-flex flex-column my-3 ml-3" > 
          <div v-if="existsClientBlockLogs && isBlocked">
            <div v-if="isGroupBlock">
              <v-icon small class="mr-2" color="error">mdi-account-group</v-icon>
              <span><strong>Bloqueio do Grupo Econômico:</strong></span>
            </div>
            <div v-else>
              <v-icon small class="mr-2" color="error">mdi-account</v-icon>
              <span><strong>Bloqueio do Cliente</strong></span>
            </div>
            <div v-if="!isGroupBlock" class="mt-1 ml-4">
              Cliente Bloqueado: {{ client?.blocked_by || client?.data?.attributes?.blocked_by }}
            </div>
            <div v-if="isGroupBlock" class="mt-2 caption">
              <v-icon x-small>mdi-information</v-icon>
              Este cliente está bloqueado devido ao bloqueio do grupo econômico. Para desbloquear, é necessário desbloquear o grupo.
            </div>
          </div>
          <div v-if="!isBlocked"> 
            <b v-if="currentBlockLog?.block_type == 'manual'">DESBLOQUEADO MANUALMENTE</b>
            <span v-else>{{status_map[client_credit.data.attributes.status_id].text}} </span>
          </div>
          <span class="subtitle-2" v-if="!isBlocked">
            Limite restante: {{Number(client_credit?.data?.attributes?.limit).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </span> 
          <div v-if="currentBlockLog?.created_at">
            <v-divider class="my-2"></v-divider>
            <span class="caption">Última atualização: {{ $moment(currentBlockLog.created_at).format("DD/MM/YYYY [às] HH:mm") }}</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex flex-column">
          <v-btn v-if="!isBlocked && canBlock && !hide_buttons && !isGroupBlock" @click="submitBlock()" rounded small class="mt-3 mx-3">
            <v-icon left small>mdi-account-lock</v-icon>
            <span>Bloquear</span>
          </v-btn>
          <v-btn v-if="isBlocked && canBlock && !hide_buttons && !isGroupBlock" @click="submitUnblock()" rounded small class="my-3 mx-3">
            <v-icon left small> mdi-account-lock-open</v-icon>
            <span>Desbloquear</span>
          </v-btn>
          <v-btn v-if="isGroupBlock && canBlock && !hide_buttons" @click="goToEconomicGroup()" rounded small class="my-3 mx-3" color="primary">
            <v-icon left small>mdi-account-group</v-icon>
            <span>Ver Grupo Econômico</span>
          </v-btn>
          <v-btn @click="checkClient()" rounded small class="my-3 mx-3">
            <v-icon left small> mdi-refresh</v-icon>
            <span>Verificar bloqueios</span>
          </v-btn>
        </div>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Api from '@/api/index'

export default {
  name: 'ClientBlockAlert',
  props:{
    client_credit:{
      type: Object,
      required: true
    },
    client:{
      type: Object,
      required: true
    },
    hide_buttons:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      saving: false,
      status_map:{
        "10": { text: "Cliente Bloqueado", type:"error" },
        "18": { text: "Cliente Bloqueado", type:"error" },
        "9": { text: "Cliente com faturas atrasadas, mas ainda há tempo para quitar", type:"warning" },
        "1": { text: "Cliente Regular", type:"success" },
      }
    }
  },
  methods: {
    checkClient(){
      this.saving = true

      Api.Client.check_credit(this.client?.data?.id || this.client?.id).then(()=>{
        this.$emit("credit_updated")
      }).finally(()=>{
        this.saving = false
      })
    },
    goToEconomicGroup(){
      let economicGroupId = this.client?.data?.attributes?.economic_group_id || this.client?.economic_group_id
      if (economicGroupId) {
        this.$router.push({ name: 'ShowEconomicGroup', params: { id: economicGroupId } })
      } else {
        this.$swal({
          title: 'Erro',
          text: 'Grupo econômico não encontrado',
          icon: 'error'
        })
      }
    },
    updateClient(client){
      this.saving = true
      Api.Client.updateCredit(client, client.id).then(()=>{
        this.successSaved()
        this.$emit("successSaved")
      }).catch(er => {
        this.errorUpdated()
      }).finally(()=>{
        this.saving = false
      })
    },
    submitBlock() {
      this.swallConfirmation({
          title: `Bloquear cliente?`,
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            let obj = {
              id: this.client?.data.id,
              forced: true,
              client_credit_attributes: {
                id: this.client_credit.data.id,
                status_id: this.allStatuses.find(o => o.attributes.title.includes("Client blocked manually")).id,
                last_change_employee_id: this.current_user_employee_id
              }
            }
            this.updateClient(obj)
          }
        })
    },
    submitUnblock() {
      this.swallConfirmation({
          title: `Desbloquear cliente?`,
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            let obj = {
              id: this.client?.data.id,
              forced: true,
            }
            obj = {
              ...obj,
              client_credit_attributes: {
                id: this.client?.data.attributes.credits.data.id,
                warned_since: null,
                status_id: this.allStatuses.find(o => o.attributes.title.includes('Active')).id,
                last_change_employee_id: this.current_user_employee_id
              },
            }
            this.updateClient(obj)
          }
        })
    },
  },
  computed: {
    isBlocked(){
      return this.client_credit.data.attributes.status_id == "10" || this.client_credit.data.attributes.status_id == "18"
    },
    existsClientBlockLogs(){
      let lastBlockLog = this.client_credit?.data?.attributes?.last_block_log
      return lastBlockLog && typeof lastBlockLog === 'object' && Object.keys(lastBlockLog).length > 0
    },
    currentBlockLog(){
      let lastBlockLog = this.client_credit?.data?.attributes?.last_block_log
      if (lastBlockLog && typeof lastBlockLog === 'object' && Object.keys(lastBlockLog).length > 0) {
        return lastBlockLog
      }
      return null
    },
    isGroupBlock(){
      // Verifica se o bloqueio é do grupo econômico
      if (this.currentBlockLog) {
        // Verifica se é bloqueio do grupo (is_group_block) ou bloqueio por grupo (block_type: 'group')
        return this.currentBlockLog.is_group_block === true || this.currentBlockLog.block_type === 'group'
      }
      return false
    },
    canBlock() {
      return this.isSalesExecutive() || this.isDirector() || this.isCreditAnalyst()
    },
    ...mapState({
      allStatuses: state => state.Status.allStatuses,
    })
  },
}
</script>